import { useTranslation } from 'react-i18next'
import { UserSalutationType } from '~api/models/index'
import { AutocompleteOption } from '~shared/components/reactHookForm/input/FormAutocomplete/FormAutocomplete'
import { AxleComponentType } from '@saf/saf-kundenportal-frontend-api/models/AxleComponentType'

export const useSalutationOptions: () => AutocompleteOption[] = () => {
  const { t } = useTranslation()

  return [
    { value: UserSalutationType.MADAM, label: t('common:missusAbbreviation') },
    { value: UserSalutationType.SIR, label: t('common:misterAbbreviation') },
    { value: UserSalutationType.DR, label: t('common:doctorAbbreviation') },
    { value: UserSalutationType.PROF, label: t('common:professorAbbreviation') },
  ]
}

export const useAxleComponentOptions: () => AutocompleteOption[] = () => {
  const { t } = useTranslation()

  return [
    { value: AxleComponentType.AXLEBODY, label: t('common:axleBody') },
    { value: AxleComponentType.COMPLETEAXLE, label: t('common:completeAxle') },
    { value: AxleComponentType.COMPLETEAGGREGATE, label: t('common:completeAggregate') },
  ]
}

export const useCourseNameOptions: () => AutocompleteOption[] = () => {
  const { t } = useTranslation()

  return [
    // { value: t('link:course1'), label: t('course:course1') },
    // { value: t('link:course2'), label: t('course:course2') },
    // { value: t('link:course3'), label: t('course:course3') },
    // { value: t('link:course4'), label: t('course:course4') },
    // { value: t('link:course5'), label: t('course:course5') },
    // { value: t('link:course6'), label: t('course:course6') },
    // { value: t('link:course7'), label: t('course:course7') },
    { value: t('link:course8'), label: t('course:course8') },
    { value: t('link:course9'), label: t('course:course9') },
    { value: t('link:course10'), label: t('course:course10') },
    { value: t('link:course11'), label: t('course:course11') },
    { value: t('link:course12'), label: t('course:course12') },
    { value: t('link:course13'), label: t('course:course13') },
  ]
}
